import apiUrl from '../../../constants'
import axios from 'axios'
// import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import moment from 'moment'


export default {
	name: 'Subcategorymaster',
	components: {
		// Paginate,
		Pagination,
		DatePicker,
		Loader
	},
	props: [],
	data() {
		return {
			// totalRows:0,
			currentPage: 1,
			totalPage: 0,
			totalCount:0,
			pageLimit:10,
			showmsg: false,
			//currentPage: 0,
			modalShow: false,
			addsubcategorymodal: false,
			subcategoryname: '',
			productcategoryname: '',
			clientname: '',
			isLoading: false,
			resultCount: '',
			// pageCount: 0,
			// pageNo: 0,
			// pageLimit: 10,
			status: '',
			changestatus: '',
			client: '',
			warehouse: '',
			clientid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			searchFlag: false,
			onaddcategory: false,
			onedit: false,
			ClientErr: '',
			ClientErrr: '',
			SubCategoryError : '',
			productCategoryError :'',
			WarehouseErr: '',
			listClientData: [],
			subcategoryaction: '',
			Fil_Obj: '',
			client_obj: '',
			listProductSubCategoryData: [],
			listProductcategoryData: [],
			listWarehouseData: [],
			ID: '',
			statusID: '',
			statusdata: '',
			addproduct: {
				subcategoryname: '',
				status: '',
				productcategoryname: '',
				clientid: '',
			},
			user_type: '',
			warehouseid: '',
			formattedDate:''
		}
	},
	computed: {

	},
	filters: {

	},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient") !=='undefined' && localStorage.getItem("selectedWarehouse") !=='undefined')
		{
		this.getProductcategorylist()
		}
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}

	},
	methods: {
		//open new form(popup)

		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },

		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		closeAddProductSubCategoryModal() {
			this.addsubcategorymodal = false
			this.clearNewForm();
		},
		closeStatusSubCategoryModal() {
			this.modalShow = false
		},
		//for active/inactive modal
		changeSubCategoryStatus() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateSubCategoryStatus',
					'data': {
						status: this.statusdata,
						id: this.statusID,
						clientid: localStorage.getItem("selectedClient")
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success("Sub-Category Status update Successfully");
						this.addsubcategorymodal = false;
						this.currentPage=1;
						this.getSubCategoryDataList();

					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException);
				})
		},
		getStatusRowData(data) {
			this.statusID = data.id
			this.statusdata = data.status
			this.Statusaction = 'add'
			this.modalShow = true
			this.status = data.status
			this.statusclientid = data.clientid
			if (data.status.trim() == 'active') {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},
		getProductcategorylist() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				categoryname: this.productcategoryname,
				clientid: this.client,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductcategorylist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listProductcategoryData = result.data.data.rows;
				}, error => {
					console.error(error);
				});
		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getSubCategoryDataList();
		// 		}
		// 	}
		// 	this.listProductSubCategoryData = [];
		// 	this.totalCount=0;
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	this.totalCount=0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getSubCategoryDataList();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		addNewProductSubCategory() {
			if (this.user_type == 'client_user') {
				this.getProductcategorylist();
			}
			this.productcategoryname = '';
			this.addproduct = [];
			this.subcategoryaction = 'add';
			this.addsubcategorymodal = true;
			this.productcategoryname = '';
			this.subcategoryname = '';
			this.addproduct.clientid = '';
			this.$validator.reset();
			this.errors.clear();
		},

		getSubCategoryDataListSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getSubCategoryDataList();
		},
		//to get client list
		getSubCategoryDataList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.ClientErrr= this.$t('common.clientError');
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listProductSubCategoryData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") =='') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listProductSubCategoryData = [];
				return false;
			}
			this.isLoading = true;
			this.input = ({
				clientid: this.client,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				subcategoryname: this.subcategoryname.trim(),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSubCategoryList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listProductSubCategoryData = result.data.data;
					this.isLoading = false;
					this.isLoading = false;
					// this.totalRows = result.data.count
					// this.resultCount = result.data.count
					// if (this.totalRows < 10) {
					// 	this.pageCount = 1
					// } else {
					// 	this.pageCount = Math.ceil(this.totalRows / 10)
					// }
					this.totalCount = result.data.count
					this.resultCount = result.data.count;
					if (this.totalCount < 10) {
						if (this.totalCount == 0){
							this.totalPage = 0
						}else{
							this.totalPage = 1
						}
					} else {
						this.totalPage = Math.ceil(this.totalCount / 10);
					}
					this.isLoading = false;
					if (result.data.count == 0) {
						this.showmsg = true
					} else {
						this.showmsg = false
					}
				}, error => {
					console.error(error);
				})
		},

		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getSubCategoryDataList();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.updateFlag = true;
			this.getSubCategoryDataList()
		},
		//To Save Category
		saveSubCategory() {
			this.ClientErrr = "",
			this.SubCategoryError= "",
			this.productCategoryError= ""
			if (this.user_type == 'client_user') {

			} else if (this.client == null) {
				this.ClientErrr= this.$t('common.clientError');
				return false;
			}
			if(!this.productcategoryname){
				this.productCategoryError  = this.$t('productPlaceHolder.productSubCategoryError')
				return false;
			}
			if(!this.subcategoryname){
				this.SubCategoryError  = this.$t('client.subCategoryNameError')
				return false;
			}


			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.client,
				categoryid: this.productcategoryname,
				subcategoryname: this.subcategoryname
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveSubCategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(" Created Successfully")
						this.addsubcategorymodal = false
						this.subcategoryname = '';
						this.getSubCategoryDataList();
						this.clearNewForm();
					} else {
						this.$alertify.error("Record Already existed")
						this.subcategoryname = ''
						document.getElementById('addsubcategoryname').value = ''
						this.addsubcategorymodal = true;
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		//to get target id in edit action
		getProductSubCategoryRowData(data) {
			this.ClientErrr = '';
			this.productCategoryError ='';
			this.SubCategoryError = '',
			this.addproduct.clientid = data.clientid
			this.getProductcategorylist();
			this.subcategoryaction = 'edit';
			this.addsubcategorymodal = true;
			this.id = data.id
			this.addproduct.clientid = data.clientid
			this.productcategoryname = data.categoryid;
			this.subcategoryname = data.subcategoryname;
			this.$validator.reset();
			this.errors.clear();
		},
		//edit Subcategorymaster
		editSubCategory() {
			this.ClientErrr = "",
			this.productCategoryError ="" ;
			this.SubCategoryError = " "
			if (this.user_type == 'client_user') {

			} else if (this.client== null) {
				this.ClientErrr= this.$t('common.clientError');
				return false;
			}
			if (this.subcategoryname == '' || this.subcategoryname == null) {
				this.SubCategoryError= this.$t('productPlaceHolder.productSubCategoryError');
				return false;
			}
			if (this.productcategoryname == '' || this.productcategoryname == null) {
				this.productCategoryError= this.$t('productPlaceHolder.productCategoryError');
				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.client,
				categoryid: this.productcategoryname,
				subcategoryname: this.subcategoryname,
				id: this.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateSubCategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(" Updated Successfully")
						this.addsubcategorymodal = false
						this.subcategoryname = '';
						this.productcategoryname='';
						this.getSubCategoryDataList();
					} else if (response.data.errorCode == -1) {
						this.$alertify.success(" Updated Successfully")
						this.productcategoryname='';
						this.addsubcategorymodal = false
						this.getSubCategoryDataList();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		//to reset search form
		resetSearchForm() {
			this.WarehouseErr = '';
			this.ClientErr = '';
			this.productCategoryError ="" ;
			this.SubCategoryError = " "
			this.subcategoryname = '';
			this.pageno = 0;
			this.searchFlag = false;
			this.showmsg = false
			this.listProductSubCategoryData = [];
			this.totalCount=0
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
		clearNewForm() {
			this.addproduct.clientid = '';
			this.productcategoryname = '';
			this.subcategoryname = '';
		},
		//validate all form fields on onsubmit()
		onSubmit: function(event) {
			this.ClientErrr = ""
			if (this.user_type == 'client_user') {

			} else if (this.client == null) {
				this.ClientErrr= this.$t('common.clientError');
				return false;
			}
			this.$validator.validateAll().then((result) => {
				if (result) {
					console.log('form is valid', this.model)
					if (this.subcategoryaction == 'add') {
						this.saveSubCategory();
					} else if (this.subcategoryaction == 'edit') {
						this.editSubCategory();
					}
				} else {
					console.log('errors exist', this.errors)
				}

				//event.target.reset();
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/subcategorymaster/subcategorymaster.component.js